//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axios';
import { BASE_URL } from '../constants/apiConstants';
import type { AxiosResponse } from '@types/axios';
interface MenuPlanType {
  menuplantypeid: string;
  menuplantypename: string;
}

interface MenuPlanState {
  menuPlantTypes: MenuPlanType[];
  loading: boolean;
  error: string | null;
}

const initialState: MenuPlanState = {
  menuPlantTypes: [],
  loading: false,
  error: null,
};


interface MenuPlanTypeResponse {
  data: {
    menuplantypes: MenuPlanType[];
  };
}
interface FetchMenuPlanTypesPayload {
  userid: string | null;
}

export const fetchMenuPlanTypes = createAsyncThunk<MenuPlanType[], FetchMenuPlanTypesPayload>(
  'menuPlan/fetchMenuPlanTypes',
  async (payload: FetchMenuPlanTypesPayload) => {
    const response: AxiosResponse<MenuPlanTypeResponse> = await axiosInstance.post(
      `${BASE_URL}/api/v1/MenuPlanType/GetMenuPlanType`,
      payload
    );   
    return response.data.data.menuplantypes;
  }
);




const menuPlanSlice = createSlice({
  name: 'menuPlan',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenuPlanTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuPlanTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlantTypes = action.payload;
      })
      .addCase(fetchMenuPlanTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch menu plan types';
      });
  },
});

export default menuPlanSlice.reducer;
